class NoAssociatedKeysError extends Error {
    public trace = false;
}

export default NoAssociatedKeysError;
